import { initModule } from '@admin/shared/util/init-module';
import { App } from '@admin/shared/components/module/app';

import { LoginModule } from '@admin/login/login';

// render desk module
const renderModule = () => {
  return (
    <App>
      <LoginModule />
    </App>
  );
};

initModule({
  moduleName: 'login',
  renderModule,
});
